import i18next from 'i18next';
import { TDict } from '../../../../types/utilityTypes';

const WOWHEAD_LANGUAGES = ['cn', 'de', 'es', 'fr', 'it', 'ko', 'pt', 'ru'];

// map from our language code to supported wowhead code
const WOWHEAD_LANGUAGE_MAP: TDict<string> = {
  zh: 'cn'
};

function getWowheadLanguage(lng: string) {
  const remappedLang = WOWHEAD_LANGUAGE_MAP[lng];
  if (remappedLang) {
    return remappedLang;
  }
  if (WOWHEAD_LANGUAGES.includes(lng)) {
    return lng;
  }
  return undefined;
}

export function buildWowheadRel(item: any, setPieces: any[], classId?: number, covenant?: number) {
  const relations = [];
  if (item.gems && item.gems.length > 0) {
    relations.push(`gems=${item.gems.join(':')}`);
  }
  if (item.enchant) {
    relations.push(`ench=${item.enchant}`);
  }
  if (item.bonuses && item.bonuses.length > 0) {
    relations.push(`bonus=${item.bonuses.join(':')}`);
  }
  if (setPieces && setPieces.length > 0) {
    const pieces = setPieces.map((it: any) => it.item_id);
    relations.push(`pcs=${pieces.join(':')}`);
  }
  if (item.heart_of_azeroth || item.item_level) {
    relations.push(`ilvl=${item.item_level}`);
  }
  if (item.azerite_powers && item.azerite_powers.length > 0 && classId) {
    relations.push(`azerite-powers=${classId}:${item.bonuses.join(':')}`);
  }
  if (covenant) {
    relations.push(`covenant=${covenant}`);
  }
  const lng = getWowheadLanguage(i18next.language);
  if (lng) {
    relations.push(`domain=${lng}`);
  }
  return relations.join('&');
}

type TWowheadItemLink = {
  iconSize?: 'small' | 'medium' | 'large';
  type?: string;
  id?: number;
  rel?: string;

  item: any;
  setPieces?: any;
  classId?: number;

  // shadowlands
  covenant?: number;

  className?: string;
  style?: any;
  children?: any;
  game?: 'retail' | 'classic' | 'era';
};

export function WowheadItemLink(props: TWowheadItemLink) {
  const { item } = props;
  const rel = buildWowheadRel(props.item, props.setPieces, props.classId, props.covenant);

  // create a switch to set BASE_URL
  let BASE_URL = '//wowhead.com';
  const game = props.game || RIO_SITE.game;
  if (game === 'wowclassic') {
    BASE_URL = '//wowhead.com/mop-classic';
  } else if (game === 'wowera') {
    BASE_URL = '//wowhead.com/classic';
  }
  return (
    <a
      {...(props.iconSize ? { 'data-wh-icon-size': props.iconSize } : {})}
      data-wh-rename-link="false"
      className={props.className || ''}
      href={`${BASE_URL}/item=${item.item_id}`}
      rel={rel}
      target="_blank"
    >
      {props.children}
    </a>
  );
}

type TWowheadLink = {
  iconSize?: 'small' | 'medium' | 'large';
  def?: number;
  rank?: number;
  ilvl?: number;
  type: string;
  id: number;

  rel?: string;
  className?: string;
  style?: any;
  children?: any;
  game?: string;
};

export function WowheadLink(props: TWowheadLink) {
  const { type, id, rel, iconSize, def, rank, ilvl } = props;

  let BASE_URL = '//wowhead.com';
  const game = props.game || RIO_SITE.game;
  if (game === 'wowclassic') {
    BASE_URL = '//wowhead.com/mop-classic';
  } else if (game === 'wowera') {
    BASE_URL = '//wowhead.com/classic';
  }

  const urlParams = [];
  if (def) {
    urlParams.push(`def=${def}`);
  }
  if (rank) {
    urlParams.push(`rank=${rank}`);
  } else if (ilvl) {
    urlParams.push(`ilvl=${ilvl}`);
  }

  const lng = getWowheadLanguage(i18next.language);
  if (lng) {
    urlParams.push(`domain=${lng}`);
  }

  const queryString = urlParams.length > 0 ? `?${urlParams.join('&')}` : '';

  let url = `${BASE_URL}/${type}=${id}${queryString}`;
  if (type === 'azerite-essence-power') {
    url = `${BASE_URL}/${type}/${id}${queryString}`;
  }
  return (
    <a
      className={props.className || ''}
      href={url}
      rel={rel}
      target="_blank"
      {...(iconSize ? { 'data-wh-icon-size': iconSize } : {})}
      style={props.style}
    >
      {props.children}
    </a>
  );
}
